// ── Tab navigation ────────────────────────────────────────────────────────────

export const DEFAULT_TAB1_LABEL = 'Details'
export const DEFAULT_TAB2_LABEL = 'Comments & Files'
export const DEFAULT_TAB3_LABEL = 'History'
export const DEFAULT_ADD_COMMENT_LABEL = 'Add Comment / File'

// ── Add Comment modal — UI labels ─────────────────────────────────────────────

export const DEFAULT_POPUP_TITLE = 'Add Comment/File'
export const DEFAULT_COMMENT_HELP_TEXT =
    '*The maximum number of characters for comments is 900. (Required)'
export const DEFAULT_TEXTAREA_PLACEHOLDER = 'Type your comment here.'
export const DEFAULT_CHAR_LIMIT = 900
export const DEFAULT_FILE_HELP_TEXT =
    'You can add only one attachment. Allowed file formats: JPG, PNG, MP4, PDF, DOCX, TXT, XLSX, CSV, PPTX, and ZIP. Maximum file size: 25.00 MB.'
export const DEFAULT_SELECT_FILE_LABEL = 'Select File'
export const DEFAULT_NO_FILE_SELECTED_LABEL = 'No file selected'
export const DEFAULT_CANCEL_LABEL = 'Cancel'
export const DEFAULT_SHARE_LABEL = 'Share'

// ── Cancel confirmation popup ────────────────────────────────────────────────

export const DEFAULT_CANCEL_CONFIRM_MESSAGE = 'Are you sure you want to cancel?'
export const DEFAULT_CANCEL_CONFIRM_YES_LABEL = 'Yes'
export const DEFAULT_CANCEL_CONFIRM_NO_LABEL = 'No'

// ── Add Comment modal — validation messages ───────────────────────────────────

export const DEFAULT_COMMENT_REQUIRED_ERROR = 'Comment is required.'
export const DEFAULT_FILE_REQUIRED_ERROR = 'Please select a file to attach.'
export const DEFAULT_FILE_TYPE_ERROR = 'Invalid file type. Allowed: JPG, PNG, MP4, PDF, DOCX, TXT, XLSX, CSV, PPTX, ZIP.'
export const DEFAULT_FILE_SIZE_ERROR = 'File size exceeds 25 MB. Please select a smaller file.'

// ── Add Comment modal — submission messages ───────────────────────────────────

export const DEFAULT_SUBMIT_SUCCESS_MESSAGE =
    'Your comment has been submitted successfully.'
export const DEFAULT_SUBMIT_ERROR_MESSAGE =
    'Failed to submit comment. Please try again.'

// ── Comments table — column headers ──────────────────────────────────────────

export const DEFAULT_COL_LAST_MODIFIED_BY = 'Last Modified By'
export const DEFAULT_COL_DATE = 'Date'
export const DEFAULT_COL_COMMENTS = 'Comments'
export const DEFAULT_COL_ATTACHMENTS = 'Attachments'
export const DEFAULT_COL_VIEW_DOWNLOAD = 'View / Download'

// ── Comments table — misc labels ─────────────────────────────────────────────

export const DEFAULT_VIEW_LABEL = 'View / Download'
export const DEFAULT_NO_COMMENTS_LABEL = 'No comments or files yet.'
export const DEFAULT_NUMBER_OF_COMMENTS_LABEL = 'Number of Comments:'
export const DEFAULT_ITEMS_PER_PAGE_LABEL = 'Items per page'
export const DEFAULT_LOADING_LABEL = 'Loading\u2026'
export const DEFAULT_FILE_DOWNLOAD_ERROR_LABEL = 'Failed to load file.'

// ── Case resolution banner ───────────────────────────────────────────────────

export const DEFAULT_RESOLUTION_BANNER_MESSAGE = 'Your case has been resolved'
export const DEFAULT_RESOLUTION_BANNER_REJECT_LABEL = 'Reject'
export const DEFAULT_RESOLUTION_BANNER_ACCEPT_LABEL = 'Accept'
export const DEFAULT_APPROVE_SUCCESS_MESSAGE = 'Case resolution accepted successfully.'
export const DEFAULT_APPROVE_ERROR_MESSAGE = 'Failed to accept case resolution. Please try again.'
export const DEFAULT_REJECT_SUCCESS_MESSAGE = 'Your response has been submitted successfully.'
export const DEFAULT_REJECT_ERROR_MESSAGE = 'Failed to submit your response. Please try again.'

// ── Case reject modal ────────────────────────────────────────────────────────

export const DEFAULT_REJECT_MODAL_TITLE = 'My Response on Case Resolution'
export const DEFAULT_REJECT_MODAL_HELP_TEXT = '*Please tell us why proposed solution does not meet your needs. (Required)'
export const DEFAULT_REJECT_MODAL_PLACEHOLDER = 'Type your comment here.'
export const DEFAULT_REJECT_MODAL_CHAR_LIMIT = 204
export const DEFAULT_REJECT_MODAL_CANCEL_LABEL = 'Cancel'
export const DEFAULT_REJECT_MODAL_SEND_LABEL = 'Send Response'
export const DEFAULT_REJECT_MODAL_REQUIRED_ERROR = 'This field is required.'
